<template>
  <!--页面主体-->
  <div class="g-container">

    <div class="m-container m-width">
      <!--面包屑-->
      <div class="crumbs-box">
        <a class="c-crumbs"
           href="">匠心记</a>
        <span class="c-sep">&gt;</span>
        <span class="c-current">创建告知函</span>
      </div>
      <!--创建告知函-->
      <div class="title radius">
        <div class="icon"></div>
        创建现场基础情况告知流程
      </div>
      <el-form :model="ruleForm"
               v-if="oneShow"
               :rules="rules"
               ref="ruleForm"
               label-position="top">
        <el-form-item label="项目名称："
                      prop="ProName">
          <el-input v-model="ruleForm.ProName"
                    placeholder="请输入项目名称" />

        </el-form-item>
        <el-form-item label="请选择项目类型（可多选）"
                      prop="YzkTagIds">
          <el-checkbox-group v-model="ruleForm.YzkTagIds"
                             direction="horizontal">
            <el-checkbox v-for="(item, index) in checkboxList"
                         :key="index"
                         :label="item.id"
                         border
                         style="margin-bottom: 10px;">{{ item.title }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="项目人员（请与QESH部门经理联系指定人员）"
                      prop="perList">
          <el-button plain
                     hairline
                     color="#999d9c"
                     icon="el-icon-plus"
                     type="primary"
                     block
                     @click="peoAdd()"
                     v-if="perBut">点击添加项目人员</el-button>
          <el-dialog :visible.sync="show"
                     title=""
                     width="600px">
            <div class="personnel">
              <ul>
                <li v-for="(item, i) in personnelList"
                    :key="i"
                    @click="personnelClick(item)">
                  <img class="personnel_pic"
                       :src="'	https://www.iduilv.com' + item.HeadImage"
                       alt=""
                       srcset="" />
                  <p>{{ item.NickName }}</p>
                  <p>{{ item.PhoneNumber | phoneFilter }}</p>
                </li>
              </ul>
            </div>
            <span slot="footer"
                  class="dialog-footer">
              <el-button @click="show = false">关闭</el-button>
            </span>
          </el-dialog>
          <div v-show="per"
               class="per"
               @click="peoAdd()"
               v-for="(item, i) in perList"
               :key="i">
            <div class="flex"
                 style="align-items: center">
              <img class="per_pic"
                   :src="'	https://www.iduilv.com' + item.HeadImage"
                   alt=""
                   srcset="" />
              <span style="margin-left: 10px">{{ item.NickName }}</span>
            </div>
            <div>{{ item.PhoneNumber | phoneFilter }}</div>
          </div>
        </el-form-item>

        <el-form-item label="客户电话："
                      v-for="(phone, index) in ruleForm.itemcount"
                      :key="index"
                      :prop="'itemcount.' + index + '.number'"
                      :rules="{ required: true, message: '请输入正确手机号', trigger: 'blur' }">
          <el-input v-model="phone.number"
                    placeholder="请输入手机号"
                    maxlength="11"></el-input>
          <el-button type=""
                     plain
                     v-if="index!=0"
                     @click="phoneDel(phone, index)"
                     icon="el-icon-delete"
                     style="margin:0 5px;color: red;"></el-button>
        </el-form-item>
        <el-button icon="el-icon-plus"
                   type="primary"
                   plain
                   @click="phoneAdd()"
                   style="margin-bottom: 10px;">客户电话</el-button>

        <el-form-item label="所属中心："
                      prop="centers">
          <el-input v-model="ruleForm.centers"
                    placeholder="请输入所属中心" />
        </el-form-item>
        <el-form-item label="所属部门："
                      prop="department">
          <el-input v-model="ruleForm.department"
                    placeholder="请输入所属部门" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="create('ruleForm')">创建流程</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 第二步 -->
    <div v-if="twoShow"
         style="width: 1200px;margin: 0 auto;">
      <el-divider content-position="left">视频上传</el-divider>
      <!-- 上传器 -->
      <uploader ref='uploader'
                :options='options'
                :file-status-text='fileStatusText'
                @file-added='onFileAdded'
                @file-success='onFileSuccess'
                @file-error='onFileError'
                class='uploader-ui'>
        <uploader-unsupport></uploader-unsupport>
        <uploader-drop>
          <div>
            <uploader-btn id='global-uploader-btn'
                          :attrs='attrs'
                          ref='uploadBtn'>
              选择文件
              <i class='el-icon-upload el-icon--right'></i>
            </uploader-btn>
          </div>
        </uploader-drop>
        <uploader-list></uploader-list>
      </uploader>
      <!-- 视频预览 -->
      <div v-if="previewUrl"
           class="video-preview">
        <video :src="previewUrl"
               controls
               playsinline
               webkit-playsinline
               width="400"></video>
      </div>
      <el-divider content-position="left">图片上传</el-divider>
      <el-upload action="/Api/Common/UploadImage"
                 list-type="picture-card"
                 accept=" image/*"
                 :on-success="handleUploadSuccess"
                 :on-preview="handlePictureCardPreview"
                 :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%"
             :src="dialogImageUrl"
             alt="">
      </el-dialog>
      <el-divider content-position="left">现场情况描述</el-divider>
      <el-input type="textarea"
                :rows="10"
                placeholder="请用文字描述现场的具体情况..."
                v-model="SiteContent">
      </el-input>
      <el-button type="primary"
                 style="margin: 10px 0;"
                 @click="twoClick()">下一步</el-button>
    </div>
    <div v-if="threeShow"
         style="width: 1200px;margin: 0 auto;">
      <el-divider content-position="left">现场基础情况异常</el-divider>
      <el-cascader :options="deviantList1"
                   :props="props"
                   :show-all-levels="false"
                   v-model="deviant1"
                   ref="cascader"
                   @change="handleChange1"
                   clearable></el-cascader>

      <el-divider content-position="left">水性专用施工机器现场情况</el-divider>
      <el-cascader :options="deviantList2"
                   :props="props"
                   :show-all-levels="false"
                   v-model="deviant2"
                   ref="cascader"
                   @change="handleChange2"
                   clearable></el-cascader>
      <div style="margin: 10px 0;">
        <el-button type="primary"
                   style="background-color: red;border: 0;"
                   @click="threeReturn()">退回</el-button>
        <el-button type="primary"
                   @click="threeClick()">提交</el-button>
      </div>

      <el-dialog title="提示"
                 :visible.sync="dialogReturn"
                 width="30%">
        <el-input type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入退回原因"
                  v-model="reason">
        </el-input>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogReturn = false">取 消</el-button>
          <el-button type="primary"
                     @click="threeReturn2()">确 定</el-button>
        </span>
      </el-dialog>

    </div>

  </div>

</template>
  
  <script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'jxjCreate',
  data () {
    // 手机号校验
    const phoneReg = /^[1][3-9][0-9]{9}$/;
    const phoneChange = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写手机号"));
      } else if (!phoneReg.test(value)) {
        callback(new Error("请填写正确的11位手机号"));
      } else {
        callback();
      }
    };

    return {
      id: '',
      ruleForm: {
        centers: "",
        department: "",
        ProName: "",
        YzkTagIds: [],
        itemcount: [{
          number: ""
        }],
        VideoUrl: "",
        VideoCoverUrl: "",
        PicPath: [],
        deviantInfo: []
      },
      checkboxList: [],
      oneShow: true,
      twoShow: false,
      threeShow: false,
      show: false,
      acc: "",
      personnelList: [],
      per: false,
      perBut: true,
      perList: [],
      perId: "",
      rules: {
        ProName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        YzkTagIds: [
          { type: 'array', required: true, message: '请选择项目类型（可多选）', trigger: 'change' }
        ],
        centers: [
          { required: true, message: '请输入所属中心', trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请输入所属部门', trigger: 'blur' }
        ],
        number: [
          { required: true, validator: phoneChange, trigger: "blur" },
        ],

      },
      options: {
        // 这里可以配置上传的 URL，以及其他选项，例如：
        target: '/Api/Common/SimpleUpload', // 比如: 'https://yourserver.com/upload'
        testChunks: false, // 是否分块上传（大文件）
        singleFile: true,//只允许上传一个
      },
      attrs: {
        accept: 'video/*',
        multiple: false // 禁用多选
      },
      fileStatusText: {
        success: '上传成功',
        error: '上传失败',
        uploading: '上传中',
        paused: '暂停',
        waiting: '等待上传'
      },
      previewUrl: null,
      dialogImageUrl: '',
      dialogVisible: false,
      SiteContent: '',
      props: {
        multiple: true,
        emitPath: false
      },
      deviantList1: [],
      deviantList2: [],
      deviant1: [],
      deviant2: [],
      dialogReturn: false,
      reason: '',
      fourText: '提交成功'
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted () {
    this.$axios.post("/Api/ProjectLog/GetTags/").then((res) => {
      if (res.data.Type == "Success") {
        this.checkboxList = res.data.Data;
      }
    });
    this.$axios.post("/Api/Noticeletter/GetProUser").then((res) => {
      if (res.data.Type == "Success") {
        console.log(res.data.Data);
        this.personnelList = res.data.Data;
      }
    });
  },
  filters: {
    phoneFilter (val) {
      let reg = /^(.{3}).*(.{4})$/;
      return val.replace(reg, "$1****$2");
    },
  },
  methods: {
    phoneAdd () {
      if (this.ruleForm.itemcount.length < 5) {
        this.ruleForm.itemcount.push({
          number: ""
        });
      }
      // console.log(this.phone)
    },
    phoneDel (item, index) {
      console.log(item, index)
      this.ruleForm.itemcount.splice(index, 1)
    },
    peoAdd () {
      this.show = true;
    },
    personnelClick (e) {
      let that = this;
      console.log(e);
      that.perBut = false;
      that.per = true;
      that.show = false;
      that.perList = [];
      that.perList.push(e);
      that.perId = e.Id;
    },
    isValidPhoneNumber (phone) {
      // 中国大陆手机号码的正则表达式
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(phone);
    },
    validatePhoneNumbers (phoneNumbers) {
      return phoneNumbers.every(item => this.isValidPhoneNumber(item.number));
    },
    create (formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.validatePhoneNumbers(this.ruleForm.itemcount)) {
            // 所有号码都有效，执行提交逻辑
            console.log('所有手机号码都有效');
            if (that.perId.toString() == "") {
              this.$message.error("请选择项目人员");
            } else {

              let CustomPhone = this.ruleForm.itemcount.map(item => item.number).join(', ');
              let params = {
                Id: 0,
                ProName: this.ruleForm.ProName,
                YzkTagIds: that.ruleForm.YzkTagIds.join(","),
                CustomPhone: CustomPhone,
                ProUserIds: that.perId,
                Center: this.ruleForm.centers,
                Dept: this.ruleForm.department,
                token: this.userInfo.token
              };
              console.log(params)
              this.$axios.post("/Api/Noticeletter/Add", params).then((res) => {
                console.log(res.data);
                if (res.data.Type == "Success") {
                  this.$message.success(res.data.Content);
                  this.id = res.data.Data
                  this.oneShow = false
                  this.twoShow = true
                  this.threeShow = false
                } else {
                  this.$message.error(res.data.Content);
                }
              })

            }
          } else {
            // 至少有一个号码无效
            this.$message.error('存在无效的手机号码，请输入正确');
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onFileAdded (file) {
      console.log('文件已添加', file);
      console.log('onFileAdded')
      // 获取当前文件列表
      const files = this.$refs.uploader.uploader.files
      if (files.length > 1) {
        this.$refs.uploader.uploader.removeFile(file)
        this.$message.error('同时只能上传一个文件')
        return false
      }
      this.popup = true
      if (file.size >= 1024 * 1024 * 200) {
        file.pause()
        this.$message({ showClose: true, message: '上传文件不可超过200MB' });
        return
      }
      var video = ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv']
      let file_type = file.name.substring(file.name.lastIndexOf(".") + 1);
      for (var i = 0; i < video.length; i++) {
        const extension = file_type === video[i];
        console.log(video[i])
        if (extension) {
          break;
        } else {
          this.popup = false
          this.file_tyle = -1
          file.pause();
        }
      }
      if (this.file_tyle == -1) {
        this.$message({ showClose: true, message: "不支持当前后缀格式" });
      }
    },
    onFileSuccess (rootFile, file, response, chunk) {
      // 文件上传成功时的处理逻辑
      console.log('文件上传成功:', JSON.parse(response));
      // 根据你的业务需求处理 response
      let res = JSON.parse(response)
      if (res.Filish) {
        this.previewUrl = res.Name
      }
      this.ruleForm.VideoUrl = JSON.parse(response).FileUrl
      this.ruleForm.VideoCoverUrl = JSON.parse(response).VideoImageUrl

    },
    onFileError (file, error) {
      console.error('文件上传失败', file, error);
    },
    handleRemove (file, fileList) {
      //   console.log(file, fileList);
      //   console.log(fileList[0].response.Data)
      var a = this.ruleForm.PicPath.filter(function (item) {
        return item !== fileList[0].response.Data;
      });
      //   console.log(a)
      this.ruleForm.PicPath = a
    },
    handlePictureCardPreview (file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleUploadSuccess (response, file, fileList) {
      console.log('文件上传成功', response);
      this.ruleForm.PicPath.push(response.Data)
      console.log(this.ruleForm.PicPath)
    },
    twoClick () {
      let that = this;
      if (this.SiteContent !== '') {
        let CustomPhone = this.ruleForm.itemcount.map(item => item.number).join(', ');
        let params = {
          Id: this.id,
          ProName: that.ruleForm.ProName,
          YzkTagIds: that.ruleForm.YzkTagIds.join(","),
          CustomPhone: CustomPhone,
          ProUserIds: that.perId,
          Center: that.ruleForm.centers,
          Dept: that.ruleForm.department,
          VideoUrl: that.ruleForm.VideoUrl,
          VideoCoverUrl: that.ruleForm.VideoCoverUrl,
          PicPath: that.ruleForm.PicPath.join(","),
          SiteContent: that.SiteContent,
          token: this.userInfo.token
        };
        console.log(params)
        this.$axios.post("/Api/Noticeletter/Add", params).then((res) => {
          console.log(res.data);
          if (res.data.Type == "Success") {
            this.$message.success(res.data.Content);
            this.oneShow = false
            this.twoShow = false
            this.threeShow = true
            this.GetDeviantList()
            this.GetDeviantList2()
          } else {
            this.$message.error(res.data.Content);
          }
        })
      } else {
        this.$message.error("请填写现场具体情况");
      }
    },
    GetDeviantList () {
      this.$axios.post("/Api/Noticeletter/GetDeviantList", {
        type: 1
      }).then((res) => {
        if (res.data.Type == "Success") {
          // this.deviantList1=res.data.Data
          let _childer_callback = function (SiteTypeId) {
            let children = [];
            for (let item of res.data.Data.DeviantList) {
              if (item.SiteTypeId == SiteTypeId) {
                children.push({
                  value: item.Id,
                  label: item.Content,
                  Aftermath: item.Aftermath
                });
              }
            }
            return children;
          };

          let _arrange_data = [];
          for (let category of res.data.Data.SiteTypeList) {
            _arrange_data.push({
              value: category.SiteTypeId,
              label: category.SiteTypeName,
              children: _childer_callback(category.SiteTypeId)
            });
          }
          this.deviantList1 = _arrange_data;
          //   console.log(_arrange_data);

        }
      });
    },
    GetDeviantList2 () {
      this.$axios.post("/Api/Noticeletter/GetDeviantList", {
        type: 2
      }).then((res) => {
        if (res.data.Type == "Success") {
          // this.deviantList1=res.data.Data
          let _childer_callback = function (SiteTypeId) {
            let children = [];
            for (let item of res.data.Data.DeviantList) {
              if (item.SiteTypeId == SiteTypeId) {
                children.push({
                  value: item.Id,
                  label: item.Content,
                  Aftermath: item.Aftermath
                });
              }
            }
            return children;
          };

          let _arrange_data = [];
          for (let category of res.data.Data.SiteTypeList) {
            _arrange_data.push({
              value: category.SiteTypeId,
              label: category.SiteTypeName,
              children: _childer_callback(category.SiteTypeId)
            });
          }
          this.deviantList2 = _arrange_data;
          //   console.log(_arrange_data);

        }
      });
    },
    handleChange1 (value, selectedData) {
      //   console.log(value.join(', '))
      console.log(value)
      this.deviant1 = value
    },
    handleChange2 (value, selectedData) {
      console.log(value)
      this.deviant2 = value
      //   console.log(selectedData)
    },
    threeClick () {
      console.log(this.deviant1)
      console.log(this.deviant2)
      let that = this;
      this.ruleForm.deviantInfo = [...this.deviant1, ...this.deviant2]
      this.fourText = '提交成功'
      let CustomPhone = this.ruleForm.itemcount.map(item => item.number).join(', ');
      let params = {
        Id: this.id,
        ProName: that.ruleForm.ProName,
        YzkTagIds: that.ruleForm.YzkTagIds.join(","),
        CustomPhone: CustomPhone,
        ProUserIds: that.perId,
        Center: that.ruleForm.centers,
        Dept: that.ruleForm.department,
        VideoUrl: that.ruleForm.VideoUrl,
        VideoCoverUrl: that.ruleForm.VideoCoverUrl,
        PicPath: that.ruleForm.PicPath.join(","),
        SiteContent: that.SiteContent,
        DeviantInfo: that.ruleForm.deviantInfo.join(","),
        token: this.userInfo.token
      };
      console.log(params)
      this.$axios.post("/Api/Noticeletter/Add", params).then((res) => {
        console.log(res.data);
        if (res.data.Type == "Success") {
          this.$message.success(res.data.Content);
          this.oneShow = false
          this.twoShow = false
          this.threeShow = true
          this.id = res.data.Data

          let params2 = {
            Id: res.data.Data,
            isConfirm: 1,
            token: this.userInfo.token
          };
          this.$axios.post("/Api/Noticeletter/Confirm", params2).then((res) => {
            console.log(res.data);
            if (res.data.Type == "Success") {
              this.$message.success(res.data.Content);
              this.oneShow = false
              this.twoShow = false
              this.threeShow = true
            } else {
              this.$message.error(res.data.Content);
            }
          })

        } else {
          this.$message.error(res.data.Content);
        }
      })
    },
    threeReturn () {
      this.dialogReturn = true
    },
    threeReturn2 () {

      if (this.reason !== '') {
        // alert('确定')
        console.log(this.userInfo.token)
        let params2 = {
          Id: this.id,
          isConfirm: 2,
          token: this.userInfo.token
        };
        this.$axios.post("/Api/Noticeletter/Confirm", params2).then((res) => {
          console.log(res.data);
          if (res.data.Type == "Success") {
            this.$message.success(res.data.Content);
            this.oneShow = false
            this.twoShow = false
            this.threeShow = true
          } else {
            this.$message.error(res.data.Content);
          }
        })
        this.oneShow = false,
          this.twoShow = false,
          this.threeShow = false
      } else {
        this.$message.error("请填写退回原因");
      }
    }

  },
  created () {

  }

}
  </script>
  
  <style  scoped>
.uploader-example {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}
.video-preview {
  margin-top: 20px;
  text-align: center;
}
.el-form {
  width: 900px;
}
.el-input {
  width: 500px;
}
.flex {
  display: flex;
}
.red {
  color: red;
}
.container {
  padding: 10px 17px;
  background-color: #f4f4f4;
}

.title {
  align-items: center;
  background-color: #fff;
  color: #1e1e1e;
  display: flex;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 10px;
  padding: 14px 10px;
}
.radius {
  border-radius: 10px;
}
.icon {
  background: #3bb680;
  height: 15px;
  margin-right: 7px;
  width: 3px;
}
.wrapper {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 15px 10px;
}
.t {
  margin-bottom: 20px;
  color: #545454;
  font-size: 13px;
}
.personnel {
  margin: 20px;
}
.personnel ul {
  flex-wrap: wrap;
  margin-top: 20px;
  padding: 0 24px;
  display: flex;
  flex-direction: row;
}

.personnel ul li {
  align-items: center;
  text-align: center;
  font-size: 12px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.personnel_pic {
  border-radius: 25px;
  height: 50px;
  margin-bottom: 13px;
  width: 50px;
}
.per {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 90%;
  color: #545454;
  font-size: 12px;
  font-weight: 400;
}
.per_pic {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
</style>
  